module.exports = __webpack_public_path__ + "media/assets/icons/reflection-footer-mail-b78e903a891bea363b60b9a4007082b7.png";